import React from 'react';
import PropTypes from 'prop-types';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Modal, Button, Row, Col } from 'antd';
import formatPrice from '~helpers/currency';
import { camelCaseToUpperFirstCase } from '~helpers';

export default class RefundModal extends React.Component {
  handleRefundDetailData = details => {
    const arrKeysList = [];
    if (details) {
      const keysList = Object.keys(details);
      while (keysList.length > 0) {
        arrKeysList.push(keysList.splice(0, 2));
      }
    }

    return arrKeysList;
  };

  render() {
    const { record, t } = this.props;
    if (!record) {
      return false;
    }

    return (
      <Modal
        visible={!!this.props.record}
        onCancel={() => {
          this.props.onCancel(null, false);
        }}
        footer={null}
        width={'880px'}
        zIndex={10000000}
        wrapClassName="refund-modal"
      >
        <div className="refund-modal__content">
          <h3 className="refund-modal__title">
            {t('landlord.long_tail.booking_details.refund_modal.title.refunded')}
          </h3>
          <label className="refund-modal__label">
            {t('landlord.long_tail.booking_details.refund_modal.label.refund_info')}
          </label>
          <Row>
            <Col span={12}>
              <span className="refund-modal__field-name">
                {t('landlord.long_tail.booking_details.refund_modal.field.refund_from', {
                  fromData: record.refundFrom
                    ? t(
                        `landlord.long_tail.booking_details.label.refund_info.refund_direction.${record.refundFrom.toLowerCase()}`,
                      )
                    : '-',
                })}
              </span>
            </Col>
            <Col span={12}>
              <span className="refund-modal__field-name">
                {t('landlord.long_tail.booking_details.refund_modal.field.refund_to', {
                  toData: record.refundTo
                    ? t(
                        `landlord.long_tail.booking_details.label.refund_info.refund_direction.${record.refundTo.toLowerCase()}`,
                      )
                    : '-',
                })}
              </span>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <span className="refund-modal__field-name">
                {t('landlord.long_tail.booking_details.refund_modal.field.refund_method', {
                  method: record.refundMethod
                    ? t(
                        `landlord.long_tail.booking_details.label.refund_info.refund_method.${record.refundMethod.toLowerCase()}`,
                      )
                    : '-',
                })}
              </span>
            </Col>
            <Col span={12}>
              <span className="refund-modal__field-name">
                {t('landlord.long_tail.booking_details.refund_modal.field.refund_amount', {
                  amount: formatPrice(record.amount, record.currency, 2),
                })}
              </span>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <span className="refund-modal__field-name">
                {t('landlord.long_tail.booking_details.refund_modal.field.number', {
                  transactionNo: record.transactionNo,
                })}
              </span>
            </Col>
          </Row>
          <If condition={record.refundFrom !== 'STCOM'}>
            <Row>
              <Col span={24}>
                <span className="refund-modal__field-name">
                  {t('landlord.long_tail.booking_details.refund_modal.field.refund_method_details')}
                </span>
              </Col>
            </Row>
            <If condition={record.refundMethodDetails}>
              <For
                of={this.handleRefundDetailData(record.refundMethodDetails)}
                each="items"
                index="key"
              >
                <Row key={key}>
                  <For of={items} each="item" index="index">
                    <Col span={12} key={index}>
                      <span className="refund-modal__field-name">
                        {`${camelCaseToUpperFirstCase(item)}: ${
                          record.refundMethodDetails[item] || '-'
                        }`}
                      </span>
                    </Col>
                  </For>
                </Row>
              </For>
            </If>
          </If>
          <If condition={this.props.showRefundComfirmBtn}>
            <p className="refund-modal__note">
              <ExclamationCircleFilled className="refund-modal__note-icon" />
              {t('landlord.long_tail.booking_details.refund_modal.note')}
            </p>
          </If>
        </div>

        <div className="refund-modal__footer">
          <Button
            className="refund-modal__btn refund-modal__btn--cancel"
            type="primary"
            size="large"
            style={{ marginBottom: 0 }}
            onClick={() => {
              this.props.onCancel(null, false);
            }}
          >
            {t('landlord.long_tail.booking_details.refund_modal.btn.close')}
          </Button>
        </div>
      </Modal>
    );
  }
}

RefundModal.propTypes = {
  t: PropTypes.func,
  onCancel: PropTypes.func,
  record: PropTypes.object,
};

RefundModal.defaultProps = {
  t: () => {},
  onCancel: () => {},
  record: null,
};
